export default __webpack_public_path__ + "static/media/islam-star.e4eeb4f1.svg";